export default __webpack_public_path__ + "static/media/cinderblock-400.7d951456.woff";